import { instanceApi } from '../../../services';
import { PositionsRequestModel, OpenClosedPositionsEmailReportRequest } from './OpenClosedPositionsSummaryModel';

export const getPositionsReport = (request: PositionsRequestModel): Promise<any> => instanceApi.post('api/analysisreport/clientspositionsreport', request);

export const sendEmailOpenClosedPositions = (data: OpenClosedPositionsEmailReportRequest): Promise<any> => instanceApi.post('api/analysisreport/sendemailopenclosedpositions', data);
